/**
 * Inline positioning for the FloatingPanel frame. Visual styling (border,
 * radius, shadow) stays with the caller's className; this only places it.
 */
import { PANEL_STATES } from "./floatingPanelConstants";

/**
 * @param {object} args
 * @param {string} args.shown  effective state: small | maximised
 * @param {{x:number,y:number}|null} args.pos  null = still CSS-anchored
 * @param {{width:(number|string), height:(number|string)}} args.size
 * @param {{top:number, right:number}} args.anchor
 * @param {number} args.zIndex
 */
export function computeFrameStyle({ shown, pos, size, anchor, zIndex }) {
  if (shown === PANEL_STATES.MAXIMISED) {
    return { position: "fixed", top: 0, right: 0, bottom: 0, left: 0, zIndex };
  }
  if (pos) {
    return { position: "fixed", left: pos.x, top: pos.y, width: size.width, height: size.height, zIndex };
  }
  return { position: "absolute", top: anchor.top, right: anchor.right, width: size.width, height: size.height, zIndex };
}

export const isNumericSize = (size) =>
  Boolean(size) && typeof size.width === "number" && typeof size.height === "number";

export const joinClassNames = (...parts) => parts.filter(Boolean).join(" ");
